import { CheckIcon } from '@chakra-ui/icons'
import { Box, Flex, Text } from '@chakra-ui/react'
import { Expandable, useFormsView, useUpdateDoc } from '@hb/react-web'
import { EditableCheckbox } from '@hb/react-web/src/components/forms/Input/EditableCheckbox'
import { CheckboxField, colors, FieldTypes } from '@hb/shared'
import { PropsWithChildren, useState } from 'react'

const field: CheckboxField = {
  type: FieldTypes.CHECKBOX,
  placeholder: 'I have read and I agree to the assessment terms',
}

export const Disclaimer = ({
  accepted,
  children,
  title,
  index,
  onCompleted,
}: PropsWithChildren<{
  accepted: boolean
  title: string
  index: number
  onCompleted: (index: number) => void
}>) => {
  const { assessment } = useFormsView()
  const [isOpen, setIsOpen] = useState(!accepted)
  const update = useUpdateDoc(`disclaimer ${index}`)
  return (
    <Expandable
      isOpen={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      header={() => (
        <Flex py={2} px={1} align="center" justify="space-between">
          <Flex align="center">
            <Flex
              w={accepted ? 5 : 0}
              justify="center"
              opacity={accepted ? 1 : 0}
              transform={`translate(${accepted ? 0 : -5}px)`}
              transition="all 333ms cubic-bezier(0.85, 0, 0.15, 1)">
              <CheckIcon w={3.5} h={3.5} color={colors.green.hex} />
            </Flex>
            <Text ml={1} color="gray.600" fontWeight={500}>
              {title}
            </Text>
          </Flex>
        </Flex>
      )}
      bg="white"
      borderRadius={4}
      border="1px solid #00000022"
      boxShadow="1px 1px 3px #00000077">
      <Flex flexFlow="column" w="100%">
        <Box w="100%" fontWeight={300} borderBottom="1px solid #cdcdcd" pt={3} pb={4} px={4}>
          {children}
        </Box>
        <Box w="100%" px={1} pt={1} pb={2}>
          <EditableCheckbox
            value={accepted}
            theme="detailed"
            id={`disclaimer-${index}`}
            field={field}
            onSubmit={val =>
              update(assessment.ref, `disclaimers.disclaimer${index}Accepted`, val).then(res => {
                setIsOpen(false)
                onCompleted(index)
                return res
              })
            }
          />
        </Box>
      </Flex>
    </Expandable>
  )
}
